module.exports = __webpack_public_path__ + "static/jc04657-preparation-step-04-3c5b6d32773a2918f11d24de079a038f.png";